var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "create") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 10,
    y: 10,
    width: 80,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 80,
    height: 60,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 10,
    y: 80,
    width: 80,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 80,
    height: 60,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Screen",
    transform: "translate(-280.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(264.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "create-inactive",
    transform: "translate(50.000000, 25.000000)",
    stroke: "#757575"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F6F6F6",
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 149,
    rx: 4
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeDasharray: 3,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeDasharray: 3,
    xlinkHref: "#path-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.b719b5d449284ba87b534fbbbadb4f2e.svg";
export { ForwardRef as ReactComponent };